import PageLoader from "components/general/PageLoader";
import Seo from "components/general/Seo";
import Pagination from "components/navigation/Pagination";
import { Box, H1, Link } from "components/ui";
import React from "react";
import RoleListing from "screens/RoleListing";
import { useGetGroupRoleQuery } from "store/abcoApi";
export default function Page() {
	const [pageNumber, setPageNumber] = React.useState(1);
	const { data, isLoading, isFetching } = useGetGroupRoleQuery({ pageNumber });

	if (isLoading || data == null) {
		return (
			<Box minHeight={150}>
				<PageLoader />
			</Box>
		);
	}

	return (
		<Box>
			<Seo title="Admin | Roles | Abconet" description="Define and assign roles to users to control their capabilities within the Abconet." />
			<RoleListing data={data} setPageNumber={setPageNumber} />
		</Box>
	);
}
